import { render } from "./ChosenField.vue?vue&type=template&id=7ff444f2"
import script from "./ChosenField.vue?vue&type=script&lang=js"
export * from "./ChosenField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__